import { render, staticRenderFns } from "./DiapersOption.vue?vue&type=template&id=4f89080a&scoped=true"
import script from "./DiapersOption.vue?vue&type=script&lang=js"
export * from "./DiapersOption.vue?vue&type=script&lang=js"
import style0 from "./DiapersOption.vue?vue&type=style&index=0&id=4f89080a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f89080a",
  null
  
)

export default component.exports